import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Loading, MessageBox, Notification } from 'element-ui';
import VueProgressiveImage from 'vue-progressive-image';
import infiniteScroll from 'vue-infinite-scroll';
import VueClipboard from 'vue-clipboard2';
import VueLazyLoad from 'vue-lazyload';
import vueScrollTo from 'vue-scrollto';
import { mask } from 'vue-the-mask';
import * as log from 'loglevel';

import App from './App.vue';
import router from './router';
import store from './store/index';
import firebase from './config/firebase';

import mixins from './shared/mixins';
import './assets/scss/theme.scss';
import TimeFilter from './shared/timeFilter';
import HumanizedTimeFilter from './shared/humanizedTimeFilter';
import DateFilter from './shared/dateFilter';
import TruncateFilter from './shared/truncateFilter';
import PodcastDateFilter from './shared/podcastDateFilter';
import TextFilter from './shared/textFilter';
import AmountFilter from './shared/amountFilter';
import TaxFilter from './shared/taxFilter';
import Analytics from './shared/analytics';
import ButtonEventDirective from './directives/button-event';
import CheckVisibleViewportDirective from './directives/check-visible-viewport';

import elementComponents from './element-components';
import PictureComponent from './components/PictureComponent';
import SvgComponent from './components/SvgComponent';
import GridCol from './components/GridCol';

import axiosInterceptor from './shared/axiosInterceptor';
import 'url-search-params-polyfill';

Object.defineProperty(Vue.prototype, '$analytics', { value: Analytics });
Vue.prototype.$eventHub = new Vue();

axiosInterceptor();

function initSentry() {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [new Sentry.Integrations.Vue()],
  });
}

function removeSplashScreen() {
  const loader = document.getElementById('loader');
  if (loader) {
    loader.classList.add('hiding');
    loader.style.zIndex = -1;
    setTimeout(() => {
      loader.style.display = 'none';
    }, 600);
  }
}

function enablePageScrolling() {
  const element = document.getElementsByTagName('html')[0];
  element.style.overflow = 'auto';
}

function checkIfTouchDevice() {
  const isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
  if (isTouch) {
    const element = document.getElementsByTagName('html')[0];
    element.classList.add('isTouch');
    window.isTouch = true;
  }
}

const initLogger = () => {
  log.setLevel(log.levels.TRACE);

  if (process.env.NODE_ENV === 'production') {
    log.setLevel(log.levels.ERROR); // Log only ERROR level logs in production. Can be set to SILENT to disable all logs completely.
  }

  log.info('Logger Initialized.');
};

elementComponents.forEach((component) => {
  Vue.component(component.name, component);
});
Vue.component('picture-component', PictureComponent);
Vue.component('svg-component', SvgComponent);
Vue.component('grid-col', GridCol);

Vue.use(VueProgressiveImage);
Vue.use(infiniteScroll);
Vue.use(VueClipboard);
Vue.use(Loading.directive);
Vue.use(vueScrollTo, {
  offset: -50,
});
Vue.use(VueLazyLoad);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$notify = Notification;

Vue.mixin(mixins);

Vue.filter('timeFormat', TimeFilter);
Vue.filter('humanizedTimeFilter', HumanizedTimeFilter);
Vue.filter('dateFormat', DateFilter);
Vue.filter('truncate', TruncateFilter);
Vue.filter('podcastDateFilter', PodcastDateFilter);
Vue.filter('textFilter', TextFilter);
Vue.filter('amountFilter', AmountFilter);
Vue.filter('taxFilter', TaxFilter);

Vue.directive('button-event', ButtonEventDirective);
Vue.directive('check-visible-viewport', CheckVisibleViewportDirective);
Vue.directive('mask', mask);

window.eventBus = new Vue();

const unsubscribe = firebase.auth().onAuthStateChanged(() => {
  unsubscribe();

  removeSplashScreen();
  enablePageScrolling();
  checkIfTouchDevice();

  window.Vue = new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
  });

  initSentry();
  initLogger();
});

// export default vueUserPortalInstance



// WEBPACK FOOTER //
// ./app/src/main.js